module.exports = __webpack_public_path__ + "img/icon-speed-6.b08c9a70.svg";